const Zine = () => {
  return (
    <div className="Zine content">
      <h2 className="contentHeading">z i n e</h2>
    </div>
  )
}

export default Zine
